import * as React from "react"
import { connect } from "react-redux"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { GlobalState } from "../../../../store"

import SourceCode from "../../../common/SourceCode"

import { DispatchProps, mapDispatchToProps } from "../../actions"
import { Labels } from "../../../../util/Translations"
import { IEditor } from "../../index"

interface StateProps {
    editor: IEditor
}

type Props = StateProps & DispatchProps

interface State {
    source: string
}

export class Editor extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        if (!!props.editor.source) {
            this.state = { source: props.editor.source }
        }
    }

    render(): JSX.Element {
        const { source } = this.state
        const { Save, Cancel } = Labels
        return (
            <div data-ft-component="SourceEditor">
                <SourceCode
                    className="tw-my-1 tw-ml-2 tw-h-150"
                    onChange={this.onChange}
                    readOnly={false}
                    value={source}
                    data-ft-component="source"
                />
                <div className="tw-pt-1 tw-pb-3 tw-pl-3 bg-lightest tw-border tw-border-solid tw-border-zinc-300">
                    <Action
                        data-ft-deployment="editor-save"
                        actionType={ActionType.button}
                        onClick={this.save}
                    >
                        {Symbols.Save} {Save}
                    </Action>
                    <Action
                        data-ft-deployment="editor-cancel"
                        actionType={ActionType.action}
                        isSecondary={true}
                        onClick={this.close}
                    >
                        {Symbols.Cancel}&nbsp;{Cancel}
                    </Action>
                </div>
            </div>
        )
    }

    onChange = (value: string): void => {
        this.setState({ source: value })
    }

    save = (): void => {
        const { source } = this.state
        const { saveSource } = this.props
        saveSource(source)
    }

    close = (): void => {
        const { closeEditor } = this.props
        closeEditor()
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    editor: state.deployment.editor,
})

export default connect(mapStateToProps, mapDispatchToProps)(Editor)
